import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { JourneyClientBootstrap } from 'journey-store';

// bootstrapApplication(AppComponent, appConfig).then(()=>{
//     new JourneyClientBootstrap().bootstrapApp().then(result=>{
//         if(result){
//             console.log('Journey client bootstrap success');
//         }
//     });
// }).catch((err) =>
//     console.error(err)
// );

new JourneyClientBootstrap().bootstrapApp().then((result) => {
    console.log('Journey bootstrap OK..');
    if (result) {
        console.log('Will bootstrap angular...');
        bootstrapApplication(AppComponent, appConfig).then(() => {
            console.log('Journey client bootstrap success');
        });
    }else{
        console.log('Will N.O.T bootstrap angular');
    }
});
